var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLightningBolt = function SvgLightningBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.096 21c-.109.5-.215.465-.305.401a.557.557 0 01-.15-.684l3.75-8.17H5.034a.527.527 0 01-.458-.266.555.555 0 01-.013-.538L9.202 2.79c.046-.088 1.114-.162.198-.213a.534.534 0 01.278-.077h6.187a.53.53 0 01.462.267.556.556 0 01.01.542l-2.679 4.983h5.303c.107 0 .21.031.3.091a.545.545 0 01.229.563.55.55 0 01-.148.281L7.476 21.341c-.05.051-.11.091-.175.118-.065.028-.135.041-.206-.459zm-1.173-9.547h5.303c.09 0 .18.024.258.069.08.044.146-.891.194.187.048.078.076-1.233.082.259a.557.557 0 01-.052.267L8.891 18.35l8.78-8.964h-4.902a.527.527 0 01-.458-.27.556.556 0 01-.008-.54l2.678-4.982H10l-4.077 7.86z"
  })));
};

export default SvgLightningBolt;